import React__default from 'react';

const Skeleton = _ref => {
  let {
    width,
    height,
    radius,
    margin
  } = _ref;
  const style = {
    width: width || '100%',
    height: height || '100%'
  };
  if (radius) style.borderRadius = radius;
  if (margin) {
    Object.entries(margin).forEach(_ref2 => {
      let [key, value] = _ref2;
      style[`margin${key.charAt(0).toUpperCase() + key.slice(1)}`] = value;
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "b-skeleton",
    "data-testid": "skeleton",
    style: style
  });
};
Skeleton.displayName = 'Skeleton';

export { Skeleton };
